// @flow
import * as React from 'react';
// $FlowIssue
import { useEffect, useContext } from 'react';
import WyngContent from 'containers/socialcollection/WyngContent';
import GetAccess from 'containers/socialcollection/GetAccess';
import Page from 'pages/__components__/LandingPage';
import type { ContextRouter } from 'react-router-dom';

import { ClientContext } from 'containers/client/ClientProvider';
import { Map } from 'immutable';

class Campaigns extends React.PureComponent<void> {
  static iframeSrc = (propertyId: string) =>
    `https://wyng.com/dashboard/content-streams/${propertyId}/list`;

  render() {
    return <WyngContent title="Campaigns" iframeSrc={Campaigns.iframeSrc} />;
  }
}

class Content extends React.PureComponent<void> {
  static iframeSrc = (propertyId: string) =>
    `https://wyng.com/curate/library/${propertyId}`;

  render() {
    return <WyngContent title="Content" iframeSrc={Content.iframeSrc} />;
  }
}

const accessRoutes = [
  {
    exact: false,
    path: 'campaigns',
    component: Campaigns,
    label: 'Campaigns',
    navItem: true,
  },
  {
    exact: false,
    path: 'content',
    label: 'Content',
    component: Content,
    navItem: true,
  },
];

const noAccessRoutes = [
  {
    exact: false,
    path: 'getaccess',
    label: 'Get Access',
    component: GetAccess,
    navItem: true,
  },
];

function useWyngDirectAccess() {
  const clientProps = useContext(ClientContext);
  const propertiesLoaded =
    clientProps != null && clientProps.properties instanceof Map;

  if (!propertiesLoaded) return null;

  return clientProps.properties.get('SOCIAL_COLLECTION_WYNG_DIRECT_ACCESS');
}

const SocialCollectionIndex = (props: { ...UserInfo, ...ContextRouter }) => {
  const socialCollectionAccess = props.access.socialcollection;
  const routes = socialCollectionAccess ? accessRoutes : noAccessRoutes;
  const wyngDirectAccess = useWyngDirectAccess();

  useEffect(() => {
    if (wyngDirectAccess === true) {
      window.location.assign('https://wyng.com/dashboard/campaigns/');
    }
  }, [wyngDirectAccess]);

  // do not render anything until we figure out if this user has direct access
  if (wyngDirectAccess == null) return null;
  // render nothing since we will be redirecting the user
  if (socialCollectionAccess && wyngDirectAccess) return null;

  return (
    <Page
      label="Social Collection"
      routes={routes}
      landingRoute={routes[0].path}
      {...props}
    />
  );
};

export default SocialCollectionIndex;



// WEBPACK FOOTER //
// ./src/pages/socialcollection.js